module.exports = __webpack_public_path__ + "media/abandon-launch.7c5a2a56.mp3";